import React from 'react'

import { HeadingLarge, HeadingMedium, BodyText } from '@pb/components'
import {
  isMonkiBrand,
  isCosBrand,
  isOtherStoriesBrand,
  isArketBrand,
  getLabelFromStorage,
} from '@pb/utils'
import cn from 'classnames'

import styles from '../ProductDetail.scss'

export const Comments = ({ commentText, setCommentText }): React.ReactElement => {
  return (
    <div className={styles.reviewQuestionsContainer}>
      <div className={styles.questionComment}>
        <>
          {isMonkiBrand ? (
            <HeadingLarge Tag="h2">
              {getLabelFromStorage('profile.unreviewedproducts.review.page.comment')}
            </HeadingLarge>
          ) : isCosBrand ? (
            <>
              <BodyText meta Tag="h2" className={cn(styles.upperCase, styles.commentHeader)}>
                {getLabelFromStorage('profile.unreviewedproducts.review.page.comment')}
              </BodyText>
              <BodyText Tag="span" meta className={styles.baseTextMeta}>
                {getLabelFromStorage('profile.unreviewedproducts.review.page.think')}
              </BodyText>
            </>
          ) : (
            <HeadingMedium
              Tag="h2"
              className={cn(styles.capitalize, isArketBrand && styles.borderHeader)}
            >
              {getLabelFromStorage('profile.unreviewedproducts.review.page.comment').toLowerCase()}
            </HeadingMedium>
          )}

          {isOtherStoriesBrand ? (
            <BodyText meta>
              {getLabelFromStorage('profile.unreviewedproducts.review.page.think')}
            </BodyText>
          ) : null}
        </>
        <textarea
          className={cn(
            { [styles.commentInput]: isArketBrand || isCosBrand },
            isCosBrand && styles.placeholder,
          )}
          rows={10}
          maxLength={5000}
          value={commentText}
          onChange={(e) => setCommentText(e.target.value)}
          placeholder={
            isArketBrand ? getLabelFromStorage('profile.unreviewedproducts.review.page.think') : ''
          }
        />
      </div>
    </div>
  )
}
